<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import TaskDetailFields from 'dashboard/modules/kanban/components/shared/TaskDetailFields.vue';

const props = defineProps({
  modelValue: { type: Object, required: true },
});
const emit = defineEmits(['update:modelValue', 'close']);

const { t } = useI18n();

// aceita due_in_days legado (automações salvas antes desta mudança)
function normalize(config) {
  if (config.due_value === undefined && config.due_in_days !== undefined) {
    return { ...config, due_value: config.due_in_days, due_unit: 'days' };
  }
  if (!config.due_unit) {
    return { ...config, due_unit: 'days' };
  }
  return config;
}

const local = ref(normalize(props.modelValue));
watch(
  () => props.modelValue,
  v => {
    local.value = normalize(v);
  },
  { deep: true }
);

function onFieldsUpdate(updated) {
  local.value = updated;
  emit('update:modelValue', updated);
}

function onKeydown(e) {
  if (e.key === 'Escape') emit('close');
}

onMounted(() => window.addEventListener('keydown', onKeydown));
onUnmounted(() => window.removeEventListener('keydown', onKeydown));
</script>

<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-[10010] flex justify-end">
      <div class="absolute inset-0 bg-n-slate-12/40" @click="emit('close')" />
      <div
        class="relative w-[420px] max-w-full h-full bg-n-background border-l border-n-weak shadow-xl overflow-y-auto flex flex-col"
      >
        <div
          class="flex items-center gap-2 px-4 pt-4 pb-2 shrink-0 border-b border-n-weak"
        >
          <h3 class="flex-1 text-base font-semibold text-n-slate-12">
            {{ t('KANBAN.AUTOMATIONS.ACTIONS.CREATE_TASK') }}
          </h3>
          <button
            class="size-9 flex-shrink-0 flex items-center justify-center rounded hover:bg-n-alpha-2 text-n-slate-9 hover:text-n-slate-12 transition-colors"
            @click="emit('close')"
          >
            <span class="i-lucide-x size-5" />
          </button>
        </div>

        <div class="px-4 py-4">
          <TaskDetailFields
            :model-value="local"
            allow-card-leader
            @update:model-value="onFieldsUpdate"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>
